var map = {
	"./9_gift.png": "c68c",
	"./Angle-left-g.png": "7294",
	"./Angle-left.png": "407c",
	"./Angle-right-g.png": "6363",
	"./Angle-right.png": "7040",
	"./BarbarianFury.png": "92a6",
	"./BattleDwarfXmas.png": "23b7",
	"./BoatBonanzaDownUnder.png": "9d98",
	"./DragonKingHotPots.png": "b099",
	"./Ellipse.png": "efd7",
	"./H5_TOP.jpg": "4ac0",
	"./HawaiianDreamXmas.png": "e196",
	"./LogoLoading_circle01.png": "8fe7",
	"./LogoLoading_circle02.png": "0b79",
	"./LogoLoading_katsu.png": "bf62",
	"./OiranDreamXmas.png": "6549",
	"./PyramidRisingx33.png": "1739",
	"./RichWildeandtheTomeofInsanity.png": "f06a",
	"./SparkofGenius.png": "0cc0",
	"./Starstruck.png": "7f34",
	"./TheGoldenOwlofAthena.png": "030e",
	"./TheSwordandtheGrailExcalibur.png": "bbeb",
	"./Withdraw-gold.svg": "171d",
	"./Withdraw-icon.svg": "4d29",
	"./about_bg04.png": "0ae5",
	"./add.svg": "00f8",
	"./affiliates.png": "027e",
	"./bankB-gold.svg": "a442",
	"./bankB-icon.svg": "1023",
	"./bg-masthead-mb.png": "3128",
	"./bg-masthead.png": "45df",
	"./bg_brush.png": "ad51",
	"./bg_repeat.png": "a63dc",
	"./bg_top.png": "7453",
	"./bitcoin-btc-gold.svg": "2ece",
	"./bitcoin-btc-logo.svg": "e7ed",
	"./blog.png": "bb49",
	"./bullhorn.svg": "1497",
	"./cach-gold.svg": "3d0e",
	"./cach-icon.svg": "70a4",
	"./card-gold.svg": "7597",
	"./card-icon.svg": "a316",
	"./ch_logo.png": "1f60",
	"./championship-bg.jpg": "6480",
	"./championship-main-event-bg.jpg": "0c0c",
	"./check-on.png": "aac5",
	"./collect.png": "987c",
	"./collect_full.png": "14c4",
	"./comments-question.svg": "a918",
	"./completed.png": "a921",
	"./creditcard-back.png": "f6ab",
	"./creditcard-front.png": "78c8",
	"./crypto-ada.svg": "f014",
	"./crypto-bnb.svg": "ea95",
	"./crypto-btc.svg": "8555",
	"./crypto-dai.svg": "f1cc",
	"./crypto-doge.svg": "a829",
	"./crypto-eos.svg": "3f53",
	"./crypto-eth.svg": "0ecc",
	"./crypto-shib.svg": "9d9c",
	"./crypto-trx.svg": "8e2c",
	"./crypto-usdc.svg": "a711",
	"./crypto-usdt.svg": "6fb5",
	"./daily-attend.png": "d3ab",
	"./db_gift_left.png": "d01c",
	"./db_gift_right.png": "5744",
	"./db_hero_img_mb.png": "c127",
	"./db_hero_img_pc.png": "104d",
	"./db_icon_coin.png": "5b5c",
	"./db_icon_lock.png": "4e5e",
	"./deposit-gold.svg": "60aa",
	"./deposit-icon.svg": "3c1b",
	"./dot-dk.svg": "94d4",
	"./dot-orange.svg": "ada5",
	"./dot.svg": "4f38",
	"./dw.png": "c1d3",
	"./electron-gold.svg": "f8a1",
	"./electron-icon.svg": "082a",
	"./email.svg": "b4d8",
	"./en_logo.png": "4d1a",
	"./event.png": "d8d7",
	"./event_specail_deposit_bg3.png": "462e",
	"./favorite.png": "f533",
	"./footer_gaming1.png": "2398",
	"./footer_gaming2.png": "8058",
	"./footer_gaming3.png": "890e",
	"./footer_gaming4.png": "18b2",
	"./fortunewheel.png": "c281",
	"./friend_promo.png": "f7ff",
	"./giftbox.png": "4db4",
	"./headset.png": "550d",
	"./heart-line.svg": "343e",
	"./heart.svg": "5fe9",
	"./history.png": "89d8",
	"./home-arrow-left.png": "914e",
	"./home-arrow-right.png": "4bb9",
	"./icon-account.png": "1dc5",
	"./icon-add.png": "dab3",
	"./icon-alert-kyc.png": "d9bc",
	"./icon-alert.png": "bc92",
	"./icon-arrow-down-2.png": "3e9b",
	"./icon-arrow-down-3.png": "a110",
	"./icon-arrow-down-4-disabled.png": "8a77",
	"./icon-arrow-down-4.png": "7b08",
	"./icon-arrow-down-gold.png": "ab44",
	"./icon-arrow-down.png": "b346",
	"./icon-arrow-dropdown.png": "d851",
	"./icon-arrow-right.png": "28fb",
	"./icon-check-black.png": "bf96",
	"./icon-check.png": "cac4",
	"./icon-checked.png": "b407",
	"./icon-close-black.png": "ed52",
	"./icon-close.png": "4297",
	"./icon-close_index_phone.png": "b998",
	"./icon-coin.png": "2879",
	"./icon-copy-2.png": "9df4",
	"./icon-copy.png": "96f0",
	"./icon-credit.png": "93c0",
	"./icon-crown.png": "6cb3",
	"./icon-date.png": "1e05",
	"./icon-detail.png": "61c1",
	"./icon-diamond.png": "8292",
	"./icon-download.png": "5225",
	"./icon-edit-dark.png": "2296",
	"./icon-edit-fill.png": "5f84",
	"./icon-expand-w.png": "d1e6",
	"./icon-favorite-active.png": "6a1d",
	"./icon-favorite.png": "afeb",
	"./icon-filter.png": "b706",
	"./icon-flag.png": "3935",
	"./icon-game-search.png": "0bec",
	"./icon-home.png": "7304",
	"./icon-info.png": "13d5",
	"./icon-invite-bonus.png": "8015",
	"./icon-invite-promo.png": "aeda",
	"./icon-invite-weekly.png": "e0d4",
	"./icon-kyc-add.png": "814a",
	"./icon-kyc-close.png": "3f94",
	"./icon-kyc-open.png": "f957",
	"./icon-lock.png": "c9ed",
	"./icon-member-active.png": "5ee8",
	"./icon-member.png": "a63d",
	"./icon-nav-home.png": "0544",
	"./icon-news-w.png": "1d7b",
	"./icon-notice.png": "3323",
	"./icon-password.png": "5876",
	"./icon-phone-active.png": "3b9d",
	"./icon-phone.png": "c6fe",
	"./icon-qrcode.png": "b3df",
	"./icon-real-name.png": "bc12",
	"./icon-recommend.png": "01f3",
	"./icon-refresh.png": "6426",
	"./icon-register-success.png": "b335",
	"./icon-search.png": "735c",
	"./icon-slot-select.png": "d9bcc",
	"./icon-slot.png": "9e01",
	"./icon-top-arrow.svg": "f7c8",
	"./icon-usdt.png": "8ff3",
	"./icon_alert.png": "60a2",
	"./icon_allgames.png": "7079",
	"./icon_awesome_bitcoin.png": "bdb6",
	"./icon_bell.png": "9dd8",
	"./icon_calendar_light.png": "e6bd",
	"./icon_card_light.png": "980f",
	"./icon_check_white.png": "ac67",
	"./icon_close.png": "7374",
	"./icon_copy_white.png": "428d",
	"./icon_download_white.png": "3ec2",
	"./icon_email.png": "becd",
	"./icon_ig.png": "d816",
	"./icon_img_01.png": "f154",
	"./icon_img_03.png": "0f71",
	"./icon_img_04.png": "ab60",
	"./icon_img_05.png": "cbeb",
	"./icon_img_06.png": "ecc1",
	"./icon_img_07.png": "74cc",
	"./icon_img_08.png": "abc5",
	"./icon_img_09.png": "93e2",
	"./icon_img_10.png": "620a",
	"./icon_img_11.png": "b86d",
	"./icon_img_12.png": "d245",
	"./icon_img_13.png": "aebc",
	"./icon_img_14.png": "c0f5",
	"./icon_img_15.png": "384f",
	"./icon_japan.png": "40fc",
	"./icon_lock_light.png": "8422",
	"./icon_metro_credit_card.png": "1727",
	"./icon_payment_bankomat.png": "ca5d",
	"./icon_promo_check.png": "1ee0",
	"./icon_promo_check_v2.png": "7b00",
	"./icon_shield_gray.png": "c7ef",
	"./icon_simple_electron.png": "00ec",
	"./icon_tab_favorite.png": "20a5",
	"./icon_tag_hot.png": "ac63",
	"./icon_tag_new.png": "0dde",
	"./icon_tag_noBonus.png": "f329",
	"./icon_trash.png": "9471",
	"./icon_twitter.png": "fe57",
	"./icon_user_light.png": "e0f6",
	"./icon_youtube.png": "a7a4",
	"./image-bank.png": "3fdc",
	"./image-upload.png": "efe2",
	"./instruction.png": "2a26",
	"./iocn-trash-fill.png": "cb4a",
	"./japan.png": "3686",
	"./jp-yen.svg": "19ca",
	"./jp_logo.png": "930c",
	"./leave.png": "3876",
	"./lights_m.png": "bcac",
	"./live.png": "cf51",
	"./login-left-2.jpg": "95f1",
	"./login-left.jpg": "5ea3",
	"./login-left.png": "f4e9",
	"./login-logo-2-mb.jpg": "6628",
	"./login-logo.jpg": "caca",
	"./logo-2.webp": "25a0",
	"./logo.png": "bbcd",
	"./logo_ft.png": "d16c",
	"./logo_katsuwin.png": "c293",
	"./lpfv-pc.png": "2e36",
	"./lpfv-sp.png": "040e",
	"./main_bg.jpg": "9deb",
	"./mall-invite-image.png": "26be",
	"./mall-product-image.png": "d8be",
	"./money_pop.png": "b7b7",
	"./monyback-gold.svg": "63c5",
	"./monyback-icon.svg": "1513",
	"./my-account.png": "88ef",
	"./my_kyc_ex1.png": "c235",
	"./my_kyc_ex2.webp": "aa91",
	"./nav-bottom-deposit-active.png": "5a42",
	"./nav-bottom-deposit.png": "bc5a",
	"./nav-bottom-game-active.png": "7561",
	"./nav-bottom-game.png": "3824",
	"./nav-bottom-home-active.png": "d640",
	"./nav-bottom-home-mobile-index.png": "fb75",
	"./nav-bottom-home.png": "65e1",
	"./nav-bottom-my-active.png": "65c9",
	"./nav-bottom-my.png": "c4fe",
	"./nav-bottom-offers-active.png": "3854",
	"./nav-bottom-offers.png": "47f5",
	"./nav-bottom-toggle.png": "c337",
	"./new_guide.png": "32ff",
	"./no-data.png": "9c8b",
	"./no.svg": "ef64",
	"./oncasy_logo.png": "55c9",
	"./pachislot.png": "54a9",
	"./program.png": "f10a",
	"./rank-1st.png": "05eb",
	"./rank-2nd.png": "8429",
	"./rank-3rd.png": "0128",
	"./register-bg.jpg": "dc80",
	"./register-logo-pc.jpg": "9db7",
	"./register-logo.jpg": "48f5",
	"./register-logo.png": "569a",
	"./registration.png": "7840",
	"./shop.png": "b51c",
	"./skill.png": "065d",
	"./slots.png": "da60",
	"./spin_wheel_bg_lt.png": "9952",
	"./spin_wheel_bg_rt.png": "cd50",
	"./stake-logo.png": "039f",
	"./structure01.png": "9d7b",
	"./structure01.svg": "e843",
	"./structure02.png": "ac4c",
	"./structure02.svg": "ccfc",
	"./structure03.png": "ad6a",
	"./structure03.svg": "767f",
	"./sup/account_mb_01.jpg": "6b10",
	"./sup/account_mb_02.jpg": "6492",
	"./sup/account_mb_03.jpg": "9d3f",
	"./sup/account_mb_03.png": "1f73",
	"./sup/account_mb_04.jpg": "04fb",
	"./sup/account_mb_05.jpg": "693d",
	"./sup/account_pc_01.png": "8452",
	"./sup/account_pc_02.png": "a174",
	"./sup/account_pc_03.png": "4e7a",
	"./sup/account_pc_04.webp": "050f",
	"./sup/account_pc_05.png": "b1b8",
	"./sup/account_pc_06.png": "0f15",
	"./sup/account_pc_07.png": "dd3a",
	"./sup/account_pc_08.png": "1e33",
	"./sup/binding_mb_tab_01.png": "7300",
	"./sup/binding_mb_tab_02.png": "5f89",
	"./sup/binding_mb_tab_03.png": "3846",
	"./sup/binding_mb_tab_04.png": "3c2d",
	"./sup/binding_mb_tab_05.png": "c0c5",
	"./sup/binding_mb_tab_06.png": "e364",
	"./sup/binding_pc_tab_01.png": "5e35",
	"./sup/binding_pc_tab_02.png": "b9f3",
	"./sup/binding_pc_tab_03.png": "cc8c",
	"./sup/binding_pc_tab_04.png": "a632",
	"./sup/binding_pc_tab_05.png": "9799",
	"./sup/binding_pc_tab_06.png": "7be0",
	"./sup/confirmID_2-2.webp": "e8d4",
	"./sup/coupon_mb_tab_01.png": "9d4a",
	"./sup/coupon_mb_tab_02.png": "7111",
	"./sup/coupon_pc_tab_01.png": "e605",
	"./sup/coupon_pc_tab_02.png": "ec74",
	"./sup/event_mb_tab_01.png": "35d2",
	"./sup/event_mb_tab_02.png": "a656",
	"./sup/event_mb_tab_03.png": "9b42",
	"./sup/event_pc_tab_01.png": "466d",
	"./sup/event_pc_tab_02.png": "7ded",
	"./sup/event_pc_tab_03.png": "6e85",
	"./sup/login_tab01_01.png": "4c3c",
	"./sup/login_tab01_02.png": "4e58",
	"./sup/login_tab01_03.png": "3baf",
	"./sup/login_tab01_04.png": "84c7",
	"./sup/login_tab01_05.png": "0828",
	"./sup/login_tab02_02.png": "fcf8",
	"./sup/login_tab02_03.png": "2a37",
	"./sup/login_tab02_04.png": "f922",
	"./sup/login_tab02_05.png": "7219",
	"./sup/login_tab03_01.png": "162e",
	"./sup/login_tab03_02.png": "a51c",
	"./sup/login_tab03_03.png": "7b3c",
	"./sup/login_tab03_04.png": "fe16",
	"./sup/login_tab03_05.png": "6142",
	"./sup/login_tab04_02.png": "3107",
	"./sup/login_tab04_03.png": "0b7b",
	"./sup/login_tab04_04.png": "43d2",
	"./sup/login_tab04_05.png": "97b5",
	"./sup/payment_mb_01.png": "82ad",
	"./sup/payment_mb_02.png": "bb0f",
	"./sup/payment_mb_03.png": "daa3",
	"./sup/payment_mb_04.png": "aba6",
	"./sup/payment_mb_05.png": "e6e3",
	"./sup/payment_mb_06.png": "1d65",
	"./sup/payment_mb_07.png": "cb86",
	"./sup/payment_mb_08.png": "2e45",
	"./sup/payment_mb_09.png": "7d2b",
	"./sup/payment_mb_10.png": "c004",
	"./sup/payment_mb_11.png": "ce16",
	"./sup/payment_pc_01.png": "905c",
	"./sup/payment_pc_02.png": "a1ed",
	"./sup/payment_pc_03.png": "ed03",
	"./sup/payment_pc_04.png": "eef8",
	"./sup/payment_pc_05.png": "f8e3",
	"./sup/payment_pc_06.png": "fd8a",
	"./sup/payment_pc_07.png": "551e",
	"./sup/payment_pc_08.png": "4cb7",
	"./sup/payment_pc_09.png": "2ca3",
	"./sup/payment_pc_10.png": "774d",
	"./sup/payment_pc_11.png": "a772",
	"./sup/payment_pc_12.png": "bdd6",
	"./sup/pc_banner_sup_acc.webp": "62b4",
	"./sup/pc_banner_sup_accout.webp": "4dba",
	"./sup/pc_banner_sup_coupon.webp": "df20",
	"./sup/pc_banner_sup_event.webp": "b795",
	"./sup/pc_banner_sup_faq.webp": "246c",
	"./sup/pc_banner_sup_faq_k.webp": "5a98",
	"./sup/pc_banner_sup_login.webp": "874c",
	"./sup/pc_banner_sup_pay.webp": "ec76",
	"./sup/pc_banner_sup_recommend.webp": "5c10",
	"./sup/pc_banner_sup_responsible.webp": "e5e1",
	"./sup/pc_banner_sup_shop.webp": "edef",
	"./sup/pc_banner_sup_vip.webp": "3da7",
	"./sup/pc_banner_sup_wallet.webp": "63e5",
	"./sup/recommended_01.webp": "a090",
	"./sup/recommended_02.webp": "1a82",
	"./sup/recommended_03.webp": "ac68",
	"./sup/recommended_04.webp": "73af",
	"./sup/recommended_05.webp": "2552",
	"./sup/register_mb_01.png": "1e3e",
	"./sup/register_mb_02.png": "f5d5",
	"./sup/register_mb_03.png": "7321",
	"./sup/register_mb_04.png": "3965",
	"./sup/register_mb_05.png": "7f1a",
	"./sup/register_pc_01.png": "95c8",
	"./sup/register_pc_02.png": "724b",
	"./sup/register_pc_03.png": "4996",
	"./sup/register_pc_04.png": "cf85",
	"./sup/register_pc_05.png": "6ead",
	"./sup/shop_mb_tab_01.png": "0aca",
	"./sup/shop_mb_tab_02.png": "6ab9",
	"./sup/shop_pc_tab_01.png": "96e2",
	"./sup/shop_pc_tab_02.png": "3afa",
	"./sup/table.png": "112d",
	"./sup/vip_mb_tab_01.png": "fbd7",
	"./sup/vip_mb_tab_02.png": "5e2d",
	"./sup/vip_mb_tab_03.png": "8c80",
	"./sup/vip_pc_tab_01.png": "4f7b",
	"./sup/vip_pc_tab_02.png": "b8ee",
	"./sup/wallet_mb_01.png": "f2cf",
	"./sup/wallet_mb_02.png": "e2f4",
	"./sup/wallet_mb_03.png": "1c8c",
	"./sup/wallet_mb_04.png": "9b3b",
	"./sup/wallet_mb_05.png": "ed58",
	"./sup/wallet_mb_06.png": "60b2",
	"./sup/wallet_pc_01.png": "ad88",
	"./sup/wallet_pc_02.png": "a184",
	"./sup/wallet_pc_03.png": "1320",
	"./sup/wallet_pc_04.png": "2d6a",
	"./sup/wallet_pc_05.png": "2b1c",
	"./sup/wallet_pc_06.png": "91fc",
	"./sup/wallet_pc_07.png": "56f7",
	"./sup/wallet_pc_08.png": "dbae",
	"./terms-bg.png": "fa81",
	"./title-championship.png": "579d",
	"./top10-bn.png": "c73d",
	"./top10-bn2.png": "273b",
	"./top_up.png": "20d1",
	"./trophy-gold.svg": "6d69",
	"./trophy-icon.svg": "257d",
	"./useful_link/agent_five.webp": "06a1",
	"./useful_link/agent_four.webp": "60b9",
	"./useful_link/agent_one.webp": "5fcc",
	"./useful_link/agent_three.webp": "b6ed",
	"./useful_link/agent_two.webp": "7dd3",
	"./useful_link/agent_validSeal.webp": "7f9e",
	"./useful_link/bg.jpg": "0a16",
	"./useful_link/bonusIntroducing.webp": "48b3",
	"./useful_link/how_to_join_1.webp": "190a",
	"./useful_link/how_to_join_2.webp": "3180",
	"./useful_link/how_to_join_3.webp": "59ec",
	"./useful_link/icon_FAQ.png": "7cef",
	"./useful_link/icon_account_binding.png": "679f",
	"./useful_link/icon_confirm_method.png": "bfc0",
	"./useful_link/icon_coupon.png": "8f9f",
	"./useful_link/icon_deposit_withdraw.png": "6942",
	"./useful_link/icon_event_bonus.png": "9679",
	"./useful_link/icon_login.png": "5314",
	"./useful_link/icon_login_method.png": "b8c0",
	"./useful_link/icon_recommended_games.png": "8068",
	"./useful_link/icon_self_restriction.png": "cd56",
	"./useful_link/icon_shop.png": "089f",
	"./useful_link/icon_vip_class_upgrading.png": "13d8",
	"./useful_link/icon_wallet.png": "50f2",
	"./useful_link/pc_banner_agent.jpeg": "b993",
	"./useful_link/pc_banner_cookie.jpeg": "e535",
	"./useful_link/pc_banner_cooperation.jpeg": "e93e",
	"./useful_link/pc_banner_cooperation.jpg": "7647",
	"./useful_link/pc_banner_privacy.jpeg": "b597",
	"./useful_link/pc_banner_rule.jpeg": "0a61",
	"./useful_link/pc_banner_support.jpeg": "7cdc",
	"./useful_link/pc_banner_terms.jpeg": "96d8",
	"./useful_link/permanentIncome.webp": "bf25",
	"./vector.svg": "e980",
	"./verify.png": "8b0d",
	"./vip-24-hours.png": "2c23",
	"./vip-arrow-left.png": "48da",
	"./vip-arrow-right.png": "275d",
	"./vip-bg.jpg": "9c2b",
	"./vip-coin-stack.png": "3313",
	"./vip-crown.png": "265a",
	"./vip-green-line.png": "c6ff",
	"./vip-roulette.png": "3807",
	"./vip-wallet.png": "9cc2",
	"./vip.png": "ab9f",
	"./vip_bg.jpg": "f21c",
	"./vip_bg.png": "29c8",
	"./vip_gift_bg.png": "5e7b",
	"./wallet.png": "480d",
	"./web_TOP.png": "7399",
	"./wheel_2x.png": "598a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6764";